'use strict'

/**
 * Project janux-vuejs-seed
 * Created by hielo on 2018-05-02
 *
 * This plugin exposes janux-demo services through a Vue.js plugin
 */

import {roleService} from './role-service'
import {authContextService} from './auth-context-service'
import {userService} from './user-service'
import {partyService} from './party-service'
import {dateUtilService} from './date-util-service'
import {userActionService} from './user-action-service'
import {validationService} from './validation-service'
import {jnxStorage} from './storage-service'

function jnxServices (Vue) {
	if (jnxServices.installed) {
		return
	}

	const roleServiceInstance = roleService(Vue.http)
	const authContextServiceInstance = authContextService(Vue.http)
	const dateUtilServiceInstance = dateUtilService(Vue.http)
	const partyServiceInstance = partyService(Vue.http, dateUtilServiceInstance)
	const userServiceInstance = userService(Vue.http, partyServiceInstance)
	const userActionServiceInstance = userActionService(Vue.http, partyServiceInstance)
	const validationServiceInstance = validationService()
	const jnxStorageInstance = jnxStorage()

	Vue.jnx = {
		roleService: roleServiceInstance,
		authContextService: authContextServiceInstance,
		userService: userServiceInstance,
		dateUtilService: dateUtilServiceInstance,
		partyService: partyServiceInstance,
		userActionService: userActionServiceInstance,
		validationService: validationServiceInstance,
		storageService: jnxStorageInstance
	}
}

if (typeof window !== 'undefined' && window.Vue) {
	window.Vue.use(jnxServices)
}

export default jnxServices



// WEBPACK FOOTER //
// ./src/common/services/index.js